import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import ValidateForm from '../../../../../../app/components/common/ValidateForm'

class Mail extends Component {
  state = {
    isAddresseeAutoValidate: false,
    isBillAddressAutoValidate: false,
    isPhoneAutoValidate: false,
    isPostCodeAutoValidate: false
  }

  hasError() {
    const addresseeHasError = this.refs.addressee.validate().hasError
    const billAddressHasError = this.refs.billAddress.validate().hasError
    const postCodeHasError = this.refs.postcode.validate().hasError
    const phoneHasError = this.refs.phone.validate().hasError
    return (
      addresseeHasError ||
      billAddressHasError ||
      postCodeHasError ||
      phoneHasError
    )
  }

  render() {
    const {
      billAddress,
      addressee,
      postcode,
      phone,
      onChangeBillAddress,
      onChangeAddressee,
      onChangePostCode,
      onChangePhone
    } = this.props

    return (
      <div>
        <FormattedMessage
          id="Fill in following information to receive a physical fapiao by mail"
        >
          {text => <p className="light">{text}</p>}
        </FormattedMessage>
        <ValidateForm
          ref="addressee"
          autoValidate={this.state.isAddresseeAutoValidate}
        >
          <input
            name="addressee"
            type="text"
            value={addressee}
            onChange={e => {
              if (e.target.value.length < 20) {
                onChangeAddressee(e.target.value)
              }
            }}
            onBlur={e => {
              if (!this.state.isAddresseeAutoValidate) {
                this.setState({ isAddresseeAutoValidate: true })
              }
            }}
            placeholder={this.props.intl.formatMessage({ id: 'Contact Name' })}
            data-error-isRequired
          />
        </ValidateForm>
        <ValidateForm
          ref="billAddress"
          autoValidate={this.state.isBillAddressAutoValidate}
        >
          <input
            name="billAddress"
            type="text"
            value={billAddress}
            onChange={e => {
              if (e.target.value.length < 110) {
                onChangeBillAddress(e.target.value)
              }
            }}
            onBlur={e => {
              if (!this.state.isBillAddressAutoValidate) {
                this.setState({ isBillAddressAutoValidate: true })
              }
            }}
            placeholder={this.props.intl.formatMessage({
              id: 'Contact Address'
            })}
            data-error-isRequired
          />
        </ValidateForm>
        <div className="field">
          <ul className="grid columns-2 padded">
            <li>
              <ValidateForm
                ref="postcode"
                autoValidate={this.state.isPostCodeAutoValidate}
              >
                <input
                  name="postcode"
                  type="text"
                  pattern="\d*"
                  value={postcode}
                  onChange={e => {
                    if (/^\d{0,6}$/.test(e.target.value)) {
                      onChangePostCode(e.target.value)
                    }
                  }}
                  onBlur={() => {
                    if (!this.state.isPostCodeAutoValidate) {
                      this.setState({ isPostCodeAutoValidate: true })
                    }
                  }}
                  placeholder={this.props.intl.formatMessage({
                    id: 'ZIP Code'
                  })}
                  data-error-isRequired
                  data-error-isPostcode
                />
              </ValidateForm>
            </li>
            <li>
              <ValidateForm
                ref="phone"
                autoValidate={this.state.isPhoneAutoValidate}
              >
                <input
                  name="phone"
                  type="text"
                  pattern="\d*"
                  value={phone}
                  onChange={e => {
                    if (/^\d{0,11}$/.test(e.target.value)) {
                      onChangePhone(e.target.value)
                    }
                  }}
                  onBlur={() => {
                    if (!this.state.isPhoneAutoValidate) {
                      this.setState({ isPhoneAutoValidate: true })
                    }
                  }}
                  placeholder={this.props.intl.formatMessage({
                    id: 'Mobile Number'
                  })}
                  data-error-isRequired
                  data-error-isPhone
                />
              </ValidateForm>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Mail
